function sortByPosition(data, positionProp) {
  return data.sort((a, b) => a[positionProp] - b[positionProp]);
}

export default sortByPosition;
